import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { deleteDocument } from '~/generated/sdk.gen';
import { extractData } from '~/utils/query-utils';

type DeleteDocumentParams = {
  documentId: number;
};

export const useDeleteDocument = (
  options: UseMutationOptions<
    unknown,
    unknown,
    DeleteDocumentParams,
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ documentId }: DeleteDocumentParams) => {
      return extractData(
        deleteDocument({
          path: { documentId },
        })
      );
    },
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({ queryKey: ['document-share'] });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
